// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__dl6ZG","link":"HeaderSimple_link__oO6LR","inputSearch":"HeaderSimple_inputSearch__P8CX5"};